export const QA_CYCLE = '.1';
export const DEFAULT_VERSION = '1.0.5';